class AmountSelector {
    constructor() {

        this.amountContainer = document.getElementById('amount-container');
        if (this.amountContainer == null)
            return;

        this.initElements();
        this.initDataAttributes();
        this.bindMethods();
        this.initializeUI();
        this.updateSentAmount();
    }

    initElements() {
        this.rangeContainer = document.getElementById('range-container');
        this.amountContainer = document.getElementById('amount-container');
        this.backArrow = document.getElementById('back-arrow');
    }

    initDataAttributes() {
        const { amountsColumns, step, receiverAmount } = this.amountContainer.dataset;
        this.amountsColumns = parseInt(amountsColumns);
        this.step = parseInt(step);
        this.receiverAmount = parseInt(receiverAmount);
        this.activeRangeButton = document.querySelector('.range-container > .boxes-btn-group.active');
    }

    bindMethods() {
        this.showRanges = this.showRanges.bind(this);
        this.showAmounts = this.showAmounts.bind(this);
        this.setAmount = this.setAmount.bind(this);
        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.handleAmountButtonClick = this.handleAmountButtonClick.bind(this);
    }

    initializeUI() {
        window.UnFreezeUI({ selector: ".transfer-summary", text: " " });
    }

    showRanges() {
        this.toggleContainers('grid', 'none');
        this.backArrow.classList.add('disabled');
    }

    showAmounts(min, max) {
        this.closeDropDown();
        this.activeRangeButton = event.target.parentElement;
        this.amountContainer.innerHTML = '';
        this.amountContainer.style.gridTemplateColumns = `repeat(${this.amountsColumns}, 1fr)`;

        for (let i = min; i <= max; i += this.step) {
            this.amountContainer.appendChild(this.createAmountButton(i));
        }

        this.toggleContainers('none', 'grid');
        this.backArrow.classList.remove('disabled');
    }

    setAmount(amount, element = null) {
        let li = element ? element.parentElement : document.querySelector(`.range-container ul > li[data-amount="${amount}"]`);

        this.clearActiveClass('.boxes-container li.active');
        li.classList.add('active');

        document.getElementById("receiverAmount").value = amount;
        document.getElementById("receiverAmountDisplay").textContent = amount;

        if (element) {
            li.parentElement.classList.remove('show');
            this.activeRangeButton = li.parentElement.parentElement;
            this.highlightActiveRange();
        }

        this.updateSentAmount();
    }

    toggleDropDown(element) {
        event.preventDefault();
        this.closeDropDown();
        element.nextElementSibling.classList.toggle('show');
    }

    closeDropDown() {
        this.clearActiveClass('.dropdown-menu.show', 'show');
    }

    createAmountButton(amount) {
        const button = document.createElement('button');
        button.classList.add('boxes-btn', 'boxes-btn-default', 'boxes-btn-amount');
        if (amount === this.receiverAmount) button.classList.add('active');
        button.textContent = amount;
        button.addEventListener('click', this.handleAmountButtonClick);
        return button;
    }

    handleAmountButtonClick(event) {
        event.preventDefault();
        this.clearActiveClass('.amount-container > .boxes-btn.active');
        event.target.classList.add('active');
        this.receiverAmount = parseInt(event.target.textContent);
        this.setAmount(this.receiverAmount);
        this.highlightActiveRange();
    }

    highlightActiveRange() {
        this.clearActiveClass('.range-container > .boxes-btn-group.active');
        this.activeRangeButton.classList.add('active');
    }

    clearActiveClass(selector, className = 'active') {
        const activeElement = document.querySelector(selector);
        if (activeElement) activeElement.classList.remove(className);
    }

    toggleContainers(rangeDisplay, amountDisplay) {
        this.rangeContainer.style.display = rangeDisplay;
        this.amountContainer.style.display = amountDisplay;
    }

    updateSentAmount() {
        document.getElementById("senderAmountDisplay").textContent = window.updateSentAmount();
    }
}

const amountSelector = new AmountSelector();
window.amountSelector = amountSelector;
